var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHome = function SvgHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4963 10.3366C10.4963 10.4999 10.4399 10.638 10.3271 10.7508C10.2144 10.8635 10.0764 10.9199 9.91313 10.9199H0.583125C0.41985 10.9199 0.281844 10.8635 0.169106 10.7508C0.0563687 10.638 0 10.4999 0 10.3366V4.21159C0 4.01714 0.0738625 3.86159 0.221587 3.74492L4.88659 0.116589C4.99544 0.0388107 5.11595 -7.82013e-05 5.24813 -7.82013e-05C5.3803 -7.82013e-05 5.50081 0.0388107 5.60966 0.116589L10.2747 3.74492C10.4224 3.86159 10.4963 4.01714 10.4963 4.21159V10.3366ZM9.33 9.75326V4.49159L5.24813 1.31826L1.16625 4.49159V9.75326H9.33Z",
    fill: "#1E1E1E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.778fa661ef3f73700fa7290e33d356b5.svg";